import CrearObligacion from './crearObligacion'

export default CrearObligacion